<div class="row text-primary py-4 container mx-auto">
  <div class="col-12 col-md-3">
    <div class="bg-white rounded p-3 text-center">
      <h4>Questions</h4>
      <div class="d-flex justify-content-center align-items-center flex-wrap mt-2">
        <ng-container *ngFor="let question of questions; index as i; trackBy: trackByIndex">
          <div class="question-pin shadow rounded-circle d-flex justify-content-center align-items-center bolder m-2"
          [class.bg-primary]="isAnswered(question.question)"
          [class.text-white]="isAnswered(question.question)">
            {{ i+1 }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-9">
    <div class="bg-white rounded p-4">
      <h4 class="mb-2">Listening part 1: Photographs</h4>
      <p>
        Listen to four statements about each photo on the screen. Choose the statement that best describes the photograph.
      </p>
      <p>
        There are 6 questions in this test.
      </p>
    </div>

    <div class="bg-white rounded p-4 mt-3">
      <div class="text-center w-50 mx-auto bg-light shadow text-primary py-2 px-4 rounded bolder">
        {{ displayDuration(currentTime) }} /&nbsp;<span class="text-muted">{{ displayDuration(totalTime) }}</span>
      </div>
      <audio #audioPlayer controls hidden></audio>
    </div>

    <!-- Questions -->
    <div class="bg-white rounded p-4 mt-3" *ngFor="let question of questions; index as i; trackBy: trackByIndex">
      <h5 class="mb-3 bolder">{{ i+1 }}.</h5>
      <div class="row mt-2">
        <div class="col-6">
          <img [src]="question.question.image | gameImage" class="img-fluid my-auto rounded-15"/>
        </div>
        <div class="col-6 d-flex flex-column justify-content-evenly">
          <ng-container *ngFor="let answer of question.affirmations; let affirmationIndex = index; trackBy: trackByIndex">
            <button class="btn rounded btn-block shadow bolder"
            [class.btn-primary]="isSelected(question.question, answer)"
            [class.text-white]="isSelected(question.question, answer)"
            [class.btn-white]="!isSelected(question.question, answer)"
            [class.text-primary]="!isSelected(question.question, answer)"
            (click)="selectAnswer(question.question, answer)">
              {{ letters[affirmationIndex] }}
            </button>
          </ng-container>
        </div>
      </div>
    </div>


    <button class="btn btn-primary btn-block bolder mt-3" (click)="next()" translate>Suivant</button>
  </div>
</div>
